import type { CompanyContentBoostType } from "@/modules/companies/client/api/contentBoostTypes"
import type { FunctionComponent } from "react"

import { PrimaryFilters } from "@/modules/jobAds/client/components/PrimaryFilters/PrimaryFilters"
import { SecondaryFiltersBar } from "@/modules/jobAds/client/components/SecondaryFiltersBar/SecondaryFiltersBar"
import {
  JOB_ADS_FO_SAVED_SEARCH_ON_MOBILE,
  JOB_ADS_FO_SAVED_SEARCH_ON_MOBILE_VARIANTS,
} from "@/modules/jobAds/client/constants/flags"
import { useJobAdsFromAlgolia } from "@/modules/jobAds/client/hooks/useJobAdsFromAlgolia"
import { usePageContext } from "@/modules/jobSearch/components/PageContext/PageContextProvider"
import { useFlag } from "@/modules/unleash/hooks/useFlag"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

import styles from "./JobAdsFilters.module.css"

export const JobAdsFilters: FunctionComponent = () => {
  const isSavedSearchOnMobileVisible = useFlag(
    JOB_ADS_FO_SAVED_SEARCH_ON_MOBILE,
    JOB_ADS_FO_SAVED_SEARCH_ON_MOBILE_VARIANTS.ENABLED
  )
  const { savedSearch } = usePageContext()
  const { dataCurrentUser } = useCurrentUserFetch()
  const { isErrorJobAds } = useJobAdsFromAlgolia<CompanyContentBoostType>()
  const hasUserSavedSearches = !!savedSearch

  const isSavedSearchVisible = !isErrorJobAds && dataCurrentUser?.isLogged && hasUserSavedSearches

  return (
    <>
      <PrimaryFilters
        className={styles.primaryFilters}
        isSavedSearchVisible={isSavedSearchVisible && isSavedSearchOnMobileVisible}
      />

      <SecondaryFiltersBar />
    </>
  )
}
